import { Image } from "@tiptap/extension-image";

export const ExtendedImage = Image.extend({
  priority: 100,
  addAttributes() {
    return {
      src: {
        default: null,
      },
      alt: {
        default: null,
      },
      title: {
        default: null,
      },
      placeholderId: {
        default: null,
      },
      style: {
        default: null,
        parseHTML: (element: HTMLElement) => {
          if (element.hasAttribute("data-emoji")) {
            return false;
          }
          return element.getAttribute("style");
        },
        renderHTML: (attributes: Record<string, unknown>) => {
          if (!attributes.style) {
            return {};
          }
          return {
            style: attributes.style,
          };
        },
      },
    };
  },
});
